import { Lootbox } from './Lootbox';

import { LotteryType } from 'Api/CRM/Responses/LotteryResponse';

export interface Ticket {
    token: string;
    lottery?: {
        name: string;
        lottery_rule_id: number;
        is_enabled: boolean;
        is_repurchase_enabled: boolean;
        type: LotteryType;
        next_draw_date: string;
        display_slug: string;
    };
    created_at: string;
    user?: {
        timezone: string;
    };
    sell_amount_gross: number;
    sell_amount_currency_code: string;
    sale_tax_sum: number;
    prize_net: number;
    draw_date: string;
    status: TicketStatus;
    prize_tax_sum: number;
    lottery_rule_id?: number;
    reseller_customer_id?: string;
    reseller_customer?: {
        name: string;
        last_name?: string;
    };
    readonly draw_name: string | null;
}

export interface TicketsResponse {
    data: Ticket[] | Lootbox[];
    current_page: number;
    last_page: number;
}

export enum TicketsRequestStatuses {
    ALL = 'all',
    WON = 'won',
    NOWINNINGS = 'nowinnings',
    CUSTOMERS = 'customers',
    PENDING = 'pending',
}
export type TicketsRequestStatus = `${TicketsRequestStatuses}`;

export enum TicketsRequestTypes {
    PAST = 'past',
    PENDING = 'pending',
    MULTIDRAWS = 'multidraws',
    SCRATCHCARDS = 'scratchcards',
    ALL = 'all',
    LOOTBOXES = 'lootboxes',
}
export type TicketsRequestType = `${TicketsRequestTypes}`;

export enum TicketStatuses {
    WON = 'won',
    NOWINNINGS = 'nowinnings',
    PENDING = 'pending',
    CANCELED = 'canceled',
}
export type TicketStatus = `${TicketStatuses}`;
